import { render, staticRenderFns } from "./SearchBarClaims.vue?vue&type=template&id=49c80aec"
import script from "../script/search/searchBarClaims.js?vue&type=script&lang=js&external"
export * from "../script/search/searchBarClaims.js?vue&type=script&lang=js&external"
import style0 from "../less/searchBar.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports